<template>
  <div class="wrap" @click.capture="isShowMenu ? (isShowMenu = false) : ''">
    <div class="page-head">
      <div
        class="area-left"
        v-if="isShowLeft"
        @click="isShowBack ? back() : (isShowMenu = !isShowMenu)"
      >
        <i class="fa-angle-left"></i>
      </div>
      <div class="area-right" v-if="isShowRight">
        <div class="avatar">
          <img :src="user.portrait" />
        </div>
      </div>
      <div class="area-mid">
        <div class="logo" v-if="!titleText"></div>
        <span v-if="titleText && !isShowSel">{{ titleText }}</span>
        <div class="select-text" v-if="isShowSel">
          <span
            >{{ robotLabel }}
            <i></i>
            <el-select
              v-model="ticket"
              placeholder="请选择"
              size="medium"
              @change="robotChange"
            >
              <el-option
                v-for="item in robotList"
                :key="item.ticket"
                :label="
                  `${item.label}${
                    item.huyaUserName ? `-${item.huyaUserName}` : ''
                  }`
                "
                :value="item.ticket"
              >
              </el-option>
            </el-select>
          </span>
        </div>
      </div>
    </div>
    <div class="foot" v-if="isShowFooter">
      <agent-footer></agent-footer>
    </div>
    <div class="page-body">
      <router-view ref="main" />
    </div>
    <!-- 
        <div class="menu" :class="{
                  show: isShowMenu
                }">
            <ul>
                <li v-for="item in menuList" :key="item.className" @click="listClick(item.eventClick)">
                    <i :class="item.className"></i>
                    {{item.title}}
                </li>
            </ul>
        </div> -->
    <el-dialog
      title="输入F码"
      :width="'95%'"
      :visible.sync="dialogShowInputFCode"
      :modal-append-to-body="false"
      @close="fcodeDialogClose"
    >
      <div class="robot-use-fcode">
        <span>对</span>
        <el-select v-model="ticket" placeholder="请选择机器人">
          <el-option
            v-for="item in robotList"
            :key="item.ticket"
            :label="
              `${item.label}${item.huyaUserName ? `-${item.huyaUserName}` : ''}`
            "
            :value="item.ticket"
          ></el-option>
        </el-select>
        <span>使用</span>
      </div>
      <el-form :model="formData">
        <el-input
          v-model.trim="formData.FCode"
          autocomplete="off"
          placeholder="请输入F码..."
          @blur="getFCodeName"
        >
          <template slot="prepend" v-if="isPC">
            <i class="fa-barcode"></i>
          </template>
        </el-input>
      </el-form>
      <div class="inline-row">{{ pName }}</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="hideDialog">取 消</el-button>
        <el-button type="primary" @click="actionFCode">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  userInfo,
  consumeFCode,
  getFCode,
  getFCodeName,
  getUserRobots,
  getWechatSdk,
  getRoomName,
  getAgentdata,
} from "@/api/index";
import { Message } from "element-ui";
import { mapState, mapActions } from "vuex";
import agentFooter from "@/components/agentFooter";
export default {
  data() {
    return {
      isShowMenu: false,
      menuList: [
        {
          className: "fa-barcode",
          title: "使用F码",
          eventClick: "barcode",
        },
        {
          className: "fa-credit-card",
          title: "续费功能",
          eventClick: "shopping",
        },
        {
          className: "fa-qq",
          title: "联系客服",
          eventClick: "contact",
        },
        {
          className: "fa-sign-out",
          title: "退出后台",
          eventClick: "logout",
        },
      ],
      dialogShowInputFCode: false,
      ticket: "",
      formData: {
        FCode: "",
      },
      pName: "",
      // robotLabel: ""
    };
  },
  components: {
    agentFooter,
  },
  computed: {
    ...mapState({
      isPC: (state) => state.isPC,
      isWeixin: (state) => state.isWeixin,
      user: (state) => state.user,
      robotList: (state) => state.robotList,
      agentType: (state) => state.agentType,
    }),
    titleText() {
      let title = "";
      if (this.$route.path == "/renew") {
        title = "续费功能";
      }
      if (this.$route.path == "/guideFcode") {
        title = "激活商业版";
      }
      if (this.$route.path == "/guideAccount") {
        title = "场控配置";
      }
      if (this.$route.path == "/guideRate") {
        title = "频率配置";
      }
      if (this.$route.path == "/guideContent") {
        title = "内容配置";
      }
      if (this.$route.path == "/guideError") {
        title = "下载客户端";
      }
      if (this.$route.path == "/contact") {
        title = "联系客服";
      }
      if (this.$route.path == "/agent") {
        title = "推广返现";
      }
      if (this.$route.path == "/details") {
        title = "佣金明细";
      }
      if (this.$route.path == "/promoters") {
        title = "代理商";
      }

      return title;
    },
    isShowBack() {
      if (this.$route.path == "/renew") {
        return true;
      }
      if (this.$route.path == "/contact") {
        return true;
      }
      if (this.$route.path == "/details") {
        return true;
      }
      return false;
    },
    isShowSel() {
      if (this.$route.path == "/renew") {
        return true;
      }
      return false;
    },
    robotLabel() {
      let robotLabel = "";
      this.robotList.forEach((item, index) => {
        if (this.ticket == item.ticket) {
          robotLabel = `${item.label}${
            item.huyaUserName ? `-${item.huyaUserName}` : ""
          }`;
        }
      });
      return robotLabel;
    },
    isShowLeft() {
      if (this.$route.path == "/agent") {
        return false;
      }
      if (this.$route.path == "/promoters") {
        return false;
      }
      if (!!~this.$route.path.indexOf("/guide")) {
        return false;
      }
      return true;
    },
    isShowRight() {
      if (this.$route.path == "/agent") {
        return false;
      }
      if (this.$route.path == "/details") {
        return false;
      }
      if (this.$route.path == "/promoters") {
        return false;
      }
      return true;
    },
    isShowFooter() {
      console.log(this.agentType);
      if (this.$route.path == "/agent" && this.agentType == 1) {
        return true;
      }
      if (this.$route.path == "/promoters" && this.agentType == 1) {
        return true;
      }
      return false;
    },
  },
  created() {
    // if(localStorage.getItem('xhd_status') == 1){
    // }else{
    // this.getUserRobots();
    // }
    // new configListener();
  },
  mounted() {
    this.changeLoadingStatus(true);
    userInfo(null, { notify: false }).then((res) => {
      if (res.code == -2050) {
        localStorage.removeItem("sid");
        if (this.$route.path != "/agent" && this.$route.path != "/login") {
          this.$router.replace("/login");
        }
      } else {
        // this.user = res.data;
        this.ticket = res.data.ticket;
        this.updateUser(res.data);
        // if (
        //   !res.data.activated &&
        //   !~location.href.indexOf('guide') &&
        //   this.$route.path != '/agent'
        // ) {
        //   this.$router.push('/guideFcode')
        //   return
        // }
        // if (localStorage['guidePage']) {
        //   this.$router.push(localStorage['guidePage'])
        //   return
        // }
        if (location.pathname == "/") {
          this.$router.replace("/robotManager");
        }
        if (this.$route.name == "agent" || this.$route.name == "promoters") {
          this.getAgentdata();
        } else {
          this.changeLoadingStatus(false);
        }
      }
    });
    if (this.isWeixin) {
      getWechatSdk(
        {
          url: location.href,
        },
        { notify: false }
      ).then((res) => {
        let data = res.data;
        wx.config({
          debug: data.debug,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          jsApiList: data.jsApiList,
        });
      });
    }
  },
  methods: {
    ...mapActions(["updateUser", "updateAgentType", "changeLoadingStatus"]),
    getUserRobots() {
      getUserRobots({ notify: false }).then(async (res) => {
        if (res.code === 0) {
          this.robotList = [];
          this.ticket = res.data.robots[0].ticket;
          for (let i = 0; i < res.data.robots.length; i++) {
            let val = res.data.robots[i];
            let index = i;
            let huyaUserName = await this.getRoomName(val.roomId);
            this.robotList.push({
              label: `${index + 1}号机器人`,
              ticket: val.ticket,
              hasCloud: val.hasCloud,
              timeRemaining:
                Math.ceil(val.cloudExpired / 86400) == 0
                  ? parseInt(val.cloudExpired / 86400)
                  : parseInt(val.cloudExpired / 86400) + 1,
              runStatus: val.runStatus,
              roomId: val.roomId,
              huyaUserName,
            });
          }
        }
      });
    },
    getRoomName(roomid) {
      return getRoomName(
        {
          roomId: roomid,
        },
        { notify: false }
      ).then((res) => {
        if (res.code == 0) {
          return res.data;
        }
        if (res.code == 500) {
          this.$message({
            dangerouslyUseHTMLString: true,
            type: "error",
            message:
              '<strong>找不到这个主播</strong><p style="margin-top: 5px;">请确认房间号是否正确</p>',
          });
        }
      });
    },
    listClick(clickName) {
      this.isShowMenu = false;
      if (clickName === "barcode") {
        this.dialogShowInputFCode = true;
      }
      if (clickName === "logout") {
        this.logout();
      }
      if (clickName === "shopping") {
        this.$router.replace({
          path: "/renew",
          query: {
            ticket: this.user.ticket,
          },
        });
      }
      if (clickName === "contact") {
        this.$router.replace({
          path: "/contact",
        });
      }
    },
    logout() {
      localStorage.removeItem("sid");
      localStorage.removeItem("avatar");
      localStorage.removeItem("user_name");
      this.$router.replace("/login");
    },
    getFCodeName() {
      if (this.formData.FCode) {
        getFCode({
          fcode: this.formData.FCode,
        }).then((res) => {
          if (res.code === 0) {
            this.pName = res.data.pname;
          }
        });
      }
    },
    hideDialog() {
      this.dialogShowInputFCode = false;
      this.formData.FCode = "";
    },
    actionFCode() {
      if (
        this.formData.FCode.length != 32 &&
        this.formData.FCode.length != 10
      ) {
        this.$message({
          dangerouslyUseHTMLString: true,
          type: "error",
          message:
            '<strong>F码位数不对</strong><p style="margin-top: 5px;">不建议手动输入，建议复制贴入</p>',
        });
        return;
      }
      if (this.formData.FCode) {
        consumeFCode({
          fcode: this.formData.FCode,
          ticket: this.ticket,
        }).then((res) => {
          if (res.code == 0) {
            this.dialogShowInputFCode = false;
            this.formData.FCode = "";
            Message({
              showClose: true,
              message: "F码使用成功！",
              type: "success",
            });
            this.$refs.main.payCompleted();
          } else {
            if (res.code == 20004) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码错误</strong><p style="margin-top: 5px;">F码错误请重新输入</p>',
              });
              // '<strong>F码位数不对</strong><p style="margin-top: 5px;">不建议手动输入，建议复制贴入</p>',
            }
            if (res.code == 20005) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">这是公会版F码，请下载公会版使用</p>',
              });
            }
            if (res.code == 20006) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">新手体验码每个账号只能使用一张</p>',
              });
            }
            if (res.code == 20007) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">这是单功能F码，无法用于新增机器人</p>',
              });
            }
            if (res.code == 20008) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">F码已被使用，如有疑问，请联系客服</p>',
              });
            }
            if (res.code == 20015) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">体验码仅限原账号使用</p>',
              });
            }
            if (res.code == 20016) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">F码已过期，体验卡请在24小时内使用</p>',
              });
            }
            if (res.code == 20017) {
              this.$message({
                dangerouslyUseHTMLString: true,
                type: "error",
                message:
                  '<strong>F码使用失败</strong><p style="margin-top: 5px;">体验卡仅限给发码机器人使用</p>',
              });
            }
          }
        });
      } else {
        Message({
          showClose: true,
          message: "请输入F码",
        });
      }
    },
    fcodeDialogClose() {
      this.formData.FCode = "";
      this.pName = "";
    },
    back() {
      // this.$router.replace("/robotManager");
      this.$router.go(-1);
    },
    robotChange(val) {
      this.$refs.main.ticketChange(val);
    },
    getAgentdata() {
      getAgentdata().then((res) => {
        if (res.code == 0) {
          this.updateAgentType(res.data.type);
        }
        this.changeLoadingStatus(false);
      });
    },
  },
};
</script>
